document.addEventListener("DOMContentLoaded", () => {
    const cartDrawer = document.getElementById("header-search-sections--18767742796000__header");
    if (!cartDrawer) {
      console.error("Елемент #header-search-sections--18767742796000__header не знайдено в DOM!");
      return;
    }
  
    const observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "open") {
          // Перевіряємо, чи є атрибут open
          if (cartDrawer.hasAttribute("open")) {
            console.log("Пошук відкрито!");
            // Ховаємо елементи
  
            const widget1 = document.getElementById("ls-menu-search")
            if(widget1){
              const inputElement = document.getElementById('ls-menu-search-input');
              inputElement.blur();
              widget1.style.display = "none"
            }
            const widget2 = document.getElementById("ls-search-mobile")
            if(widget2){
              const inputElement = document.getElementById('ls-menu-search-mobile-input');
              inputElement.blur();
              widget2.style.display = "none"
            }
            
            
          } else {
            console.log("Пошук закрито!");
            const widget1 = document.getElementById("ls-menu-search")
            if(widget1){
              widget1.style.display = "";
              const inputElement = document.getElementById('ls-menu-search-input');
              inputElement.blur();
              document.body.focus();
            }
            const widget2 = document.getElementById("ls-search-mobile")
            if(widget2){
              widget2.style.display = ""
              const inputElement = document.getElementById('ls-menu-search-mobile-input');
              inputElement.blur();
              document.body.focus();
            }
          }
        }
      });
    });
  

    const config = {
      attributes: true,
      attributeFilter: ["open"],
    };

    observer.observe(cartDrawer, config);
  
});